// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-export"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 20H2V3.5H9L11 6H22V12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.0419 21.502L22.5021 18.0019L19.0419 14.502M21.3 18.002H13.998","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderExportIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-export',
    ref,
    icon: element,
  },
));

FolderExportIcon.displayName = 'FolderExportIcon';

export default FolderExportIcon;
